import React from 'react';
import {render} from 'react-dom';
import {Provider, connect} from 'react-redux';
import {createStore} from 'redux';
import Form from './inviter/form';
import inviteeReducer from './inviter/reducer';
import mapDispatchToProps from './inviter/map_dispatch_to_props';
const csfrToken = document.getElementsByName('csrf-token')[0];
const authenticationToken = csfrToken != null ? csfrToken.getAttribute('content') : '';

const initial_state = {invitees: [{ invitee: '', v: 1 }, {invitee: '', v:2 }, {invitee: '', v:3 }, {invitee: '', v:4 }]};
const store = createStore(inviteeReducer, initial_state);

function mapStateToProps(state) {
    return {
        store: state,
        authenticationToken: authenticationToken
    }
}

const ConnectedForm = connect(mapStateToProps, mapDispatchToProps)(Form);

class Inviter extends React.Component {

    render() {
        return (
            <Provider store={store}>
                <ConnectedForm
                    brewery={this.props.brewery}
                    hideHeader={this.props.hideHeader}
                    fromBreweryPage={this.props.fromBreweryPage}
                    adminOnly={this.props.adminOnly}
                />
            </Provider>
        );
    }
}

export default Inviter